import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairportcab() {



  const cardData = {




keyword: "Navi Mumbai Airport Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Navi Mumbai Airport Cab Service for business travelers, families, tourists, students, senior citizens, and groups requiring convenient airport transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for airport pickup and drop, hotel transfers, corporate travel, railway station transfers, residential travel, intercity journeys, and customized transportation plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flight-based pickup coordination, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes airport travel around Navi Mumbai smooth and convenient. Travelers can arrange direct transfers to business parks, residential areas, hotels, railway stations, shopping destinations, and nearby cities according to their preferred schedule.",

topPlaces: [
  {
    title: "Vashi",
    description: "Vashi is one of the most established commercial and residential areas of Navi Mumbai, known for shopping centers, business establishments, hotels, and excellent transportation connectivity. Travelers using Navi Mumbai Airport can conveniently reach Vashi by private cab. Garud Cab Service provides comfortable chauffeur-driven vehicles with flexible airport pickup and drop arrangements."
  },
  {
    title: "Belapur",
    description: "Belapur is an important administrative and business hub of Navi Mumbai with corporate offices, government establishments, residential communities, and commercial areas. Airport passengers can arrange direct cab transportation to Belapur without changing vehicles. Customers can choose a suitable Sedan, SUV, Ertiga, Innova, or Innova Crysta according to their travel requirements."
  },
  {
    title: "Kharghar",
    description: "Kharghar is a well-developed Navi Mumbai locality known for educational institutions, residential communities, commercial areas, and scenic surroundings. Travelers arriving at Navi Mumbai Airport can reach Kharghar comfortably through a private airport cab. Garud Cab Service offers convenient pickup coordination and spacious vehicles for passengers carrying luggage."
  },
  {
    title: "Nerul",
    description: "Nerul is a popular residential and commercial locality in Navi Mumbai with railway connectivity, educational institutions, business establishments, and family-friendly areas. Passengers arriving at the airport can book a direct cab to Nerul for convenient door-to-door transportation. Customers can travel comfortably with professional chauffeurs and flexible schedules."
  },
  {
    title: "Panvel",
    description: "Panvel is an important transportation and commercial hub located close to Navi Mumbai Airport and provides connectivity toward Mumbai, Pune, and several coastal destinations. Airport travelers can book a private cab for direct transportation to Panvel. Garud Cab Service provides comfortable vehicles suitable for individuals, families, and groups with luggage."
  },
  {
    title: "Ulwe",
    description: "Ulwe is a rapidly developing Navi Mumbai locality located close to the airport and is known for new residential projects, commercial developments, and convenient road connectivity. Travelers arriving at Navi Mumbai Airport can reach Ulwe quickly and comfortably by private cab. Customers can schedule airport pickup according to their flight arrival time."
  },
  {
    title: "Airoli",
    description: "Airoli is an important IT and business destination in Navi Mumbai with corporate offices, technology parks, residential communities, and commercial establishments. Business travelers arriving at Navi Mumbai Airport can use a private cab for direct transportation to their workplace or hotel. Garud Cab Service offers professional drivers and suitable vehicles for corporate transfers."
  },
  {
    title: "Ghansoli",
    description: "Ghansoli is a growing business and residential locality in Navi Mumbai, attracting professionals because of its corporate offices, technology facilities, and modern housing developments. Customers arriving through the airport can book a comfortable cab for direct transportation to Ghansoli. Flexible pickup and drop arrangements make the journey convenient for business and family travelers."
  },
  {
    title: "Juinagar",
    description: "Juinagar is a well-connected Navi Mumbai locality with residential areas, commercial establishments, railway connectivity, and convenient access to nearby business districts. Airport passengers can choose private cab transportation for a comfortable journey from the airport to their destination. Garud Cab Service provides suitable vehicles with sufficient seating and luggage space."
  },
  {
    title: "Thane",
    description: "Thane is a major city in the Mumbai Metropolitan Region and is accessible from Navi Mumbai through important road connections. Travelers arriving at Navi Mumbai Airport can arrange direct cab transportation to Thane for business, family, hotel, or personal travel. Garud Cab Service offers comfortable long-distance airport transfers with flexible pickup and drop schedules."
  }
],





"services": [
{
"name": "Navi Mumbai Airport Cab",
"description": "Book Navi Mumbai Airport Cab for comfortable and convenient airport transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for passengers traveling to or from the airport for business trips, family journeys, tourism, and personal travel."
},
{
"name": "Navi Mumbai Airport Taxi",
"description": "Choose Navi Mumbai Airport Taxi for reliable point-to-point transportation with convenient pickup and drop arrangements. Sedan, SUV, Innova, and premium vehicle options can be arranged according to passenger count, luggage, and travel requirements."
},
{
"name": "Navi Mumbai Airport Cab Service",
"description": "Book Navi Mumbai Airport Cab Service for convenient chauffeur-driven airport transportation with scheduled pickup and drop facilities. The service is suitable for individuals, families, corporate passengers, tourists, and travelers requiring private airport transfers."
},
{
"name": "Navi Mumbai Airport Taxi Service",
"description": "Choose Navi Mumbai Airport Taxi Service for comfortable airport travel with experienced drivers and well-maintained vehicles. Suitable cab categories can be arranged for business travel, family journeys, tourist transfers, and personal airport transportation."
},
{
"name": "Cab Service at Navi Mumbai Airport",
"description": "Book Cab Service at Navi Mumbai Airport for convenient transportation between the airport and your preferred destination. Private chauffeur-driven vehicles can be arranged for passengers requiring comfortable transfers, luggage assistance, flexible pickup times, and direct travel."
},
{
"name": "Taxi Service at Navi Mumbai Airport",
"description": "Choose Taxi Service at Navi Mumbai Airport for practical and comfortable airport transportation with professional chauffeur assistance. The service is suitable for arriving and departing passengers, families, business travelers, tourists, and individuals."
},
{
"name": "Airport Cab Navi Mumbai",
"description": "Reserve Airport Cab Navi Mumbai for convenient private transportation to or from the airport. Comfortable AC cars and spacious vehicle options can be selected according to passenger requirements, luggage capacity, travel schedule, and destination."
},
{
"name": "Navi Mumbai Airport Cab Booking",
"description": "Make Navi Mumbai Airport Cab Booking in advance to arrange a private vehicle according to your preferred pickup time and destination. Sedan, SUV, Innova, and premium options can be selected for airport transfers, business travel, family trips, and tourism."
},
{
"name": "Navi Mumbai Airport Taxi Booking Online",
"description": "Book Navi Mumbai Airport Taxi Booking Online for convenient advance planning without visiting a booking office. Customers can arrange chauffeur-driven airport transportation based on travel timing, passenger count, luggage, vehicle category, and pickup requirements."
},
{
"name": "Navi Mumbai Airport Cab Fare",
"description": "Check Navi Mumbai Airport Cab Fare according to the selected vehicle, pickup location, destination, travel schedule, and journey requirements. Different vehicle categories can be arranged to provide practical transportation for individuals, families, corporate travelers, and groups."
},
{
"name": "Navi Mumbai Airport Taxi Charges",
"description": "Check Navi Mumbai Airport Taxi Charges based on the vehicle category and overall airport transfer requirements. Sedan, SUV, Innova, and premium vehicles can be selected according to passenger capacity, luggage, destination, and preferred comfort level."
},
{
"name": "Navi Mumbai Airport Cab Price",
"description": "Find Navi Mumbai Airport Cab Price according to the chosen vehicle type, pickup and drop location, travel schedule, and journey requirements. Chauffeur-driven cars can be arranged for airport transfers, business passengers, families, tourists, and personal travel."
},
{
"name": "Best Navi Mumbai Airport Cab Service",
"description": "Choose the Best Navi Mumbai Airport Cab Service for comfortable and dependable airport transportation with professional chauffeurs and well-maintained vehicles. The service is suitable for corporate travel, family journeys, tourist transfers, and scheduled airport pickups and drops."
},
{
"name": "Cheap Navi Mumbai Airport Cab",
"description": "Book a Cheap Navi Mumbai Airport Cab for economical airport transportation while maintaining convenient private travel. Practical sedan and other vehicle options can be arranged for students, individuals, families, business travelers, and budget-conscious passengers."
},
{
"name": "24x7 Navi Mumbai Airport Cab Service",
"description": "Choose 24x7 Navi Mumbai Airport Cab Service for airport transportation at different hours of the day and night. The service is suitable for early-morning departures, late-night arrivals, business travel, family trips, and passengers with scheduled flight timings."
},
{
"name": "Navi Mumbai Airport Innova Cab",
"description": "Book Navi Mumbai Airport Innova Cab for spacious and comfortable airport transportation suitable for families and small groups. The vehicle provides practical seating and luggage capacity for airport pickups, drops, business travel, and longer intercity journeys."
},
{
"name": "Navi Mumbai Airport Ertiga Cab",
"description": "Choose Navi Mumbai Airport Ertiga Cab for comfortable group transportation with practical seating and luggage space. It is suitable for families, small groups, corporate passengers, and travelers looking for convenient private transportation to or from the airport."
},
{
"name": "Navi Mumbai Airport Sedan Taxi",
"description": "Book Navi Mumbai Airport Sedan Taxi for comfortable AC transportation suitable for individuals, couples, and small families. Sedan vehicles provide practical seating and luggage capacity for airport transfers, business trips, personal travel, and scheduled pickups."
},
{
"name": "Navi Mumbai Airport SUV Cab",
"description": "Choose Navi Mumbai Airport SUV Cab for spacious airport transportation with additional seating and luggage capacity. The service is suitable for families, groups, corporate travelers, tourists, and passengers carrying additional luggage during airport transfers."
},
{
"name": "Navi Mumbai Airport AC Cab",
"description": "Book Navi Mumbai Airport AC Cab for comfortable climate-controlled transportation throughout your airport journey. The service is suitable for families, business travelers, tourists, and individuals who prefer private airport travel with professional chauffeur assistance."
},
{
"name": "Navi Mumbai Airport Luxury Cab",
"description": "Choose Navi Mumbai Airport Luxury Cab for premium and comfortable airport transportation with enhanced interiors and professional chauffeur service. It is suitable for executives, corporate passengers, special occasions, business travel, and travelers seeking a more comfortable airport transfer."
}
],
"tableData": [
["Navi Mumbai Airport Cab", "Navi Mumbai Airport Taxi"],
["Navi Mumbai Airport Cab Service", "Navi Mumbai Airport Taxi Service"],
["Cab Service at Navi Mumbai Airport", "Taxi Service at Navi Mumbai Airport"],
["Airport Cab Navi Mumbai", "Navi Mumbai Airport Cab Booking"],
["Navi Mumbai Airport Taxi Booking Online", "Navi Mumbai Airport Cab Fare"],
["Navi Mumbai Airport Taxi Charges", "Navi Mumbai Airport Cab Price"],
["Best Navi Mumbai Airport Cab Service", "Cheap Navi Mumbai Airport Cab"],
["24x7 Navi Mumbai Airport Cab Service", "Navi Mumbai Airport Innova Cab"],
["Navi Mumbai Airport Ertiga Cab", "Navi Mumbai Airport Sedan Taxi"],
["Navi Mumbai Airport SUV Cab", "Navi Mumbai Airport AC Cab"],
["Navi Mumbai Airport Luxury Cab", "Navi Mumbai Airport Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Navi Mumbai Airport Cab for Convenient Airport Travel",
    WhyChoosedescription: "A private cab is a practical choice for passengers travelling to or from Navi Mumbai Airport, offering direct transportation for families, business travellers, tourists, students, and groups with different travel requirements."
  },
  {
    WhyChooseheading: "Direct Airport Pickup & Drop",
    WhyChoosedescription: "Passengers can arrange a direct pickup from Navi Mumbai Airport to their preferred home, hotel, office, or other destination, or schedule an airport drop from a convenient location."
  },
  {
    WhyChooseheading: "Travel Around Your Flight Schedule",
    WhyChoosedescription: "Airport transportation can be planned around your departure or arrival schedule, helping passengers coordinate their cab journey with domestic or international flight plans."
  },
  {
    WhyChooseheading: "Comfortable for Families & Groups",
    WhyChoosedescription: "Families, couples, and groups can select a suitable vehicle based on passenger count, luggage quantity, and comfort requirements for a convenient airport transfer."
  },
  {
    WhyChooseheading: "Useful for Corporate Airport Transfers",
    WhyChoosedescription: "Professionals travelling for meetings, conferences, client visits, office assignments, or business events can arrange private transportation between Navi Mumbai Airport and their required destination."
  },
  {
    WhyChooseheading: "Convenient for Mumbai & Navi Mumbai Travel",
    WhyChoosedescription: "Passengers travelling between Mumbai, Navi Mumbai, and the airport can use private cab transportation for direct point-to-point journeys without unnecessary vehicle changes."
  },
  {
    WhyChooseheading: "Suitable for Luggage-Friendly Transfers",
    WhyChoosedescription: "Travellers carrying suitcases and other permitted luggage can choose a vehicle according to their passenger and baggage requirements for a smoother airport transfer."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your pickup or drop location, airport travel date, flight details when applicable, passenger count, luggage requirements, and preferred vehicle with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Navi Mumbai Airport Cab Service?",
    answer: "Yes, Garud Cab Service provides private cab services for Navi Mumbai Airport pickups and drops for families, professionals, tourists, students, couples, and groups."
  },
  {
    question: "Can I book a pickup from Navi Mumbai Airport?",
    answer: "Yes, passengers arriving at Navi Mumbai Airport can arrange a private cab for direct transportation to their preferred home, hotel, office, or other accessible destination."
  },
  {
    question: "Can I book a cab to Navi Mumbai Airport for my flight?",
    answer: "Yes, airport drop transportation can be arranged from a preferred pickup location according to your planned flight schedule."
  },
  {
    question: "Is Navi Mumbai Airport cab suitable for families?",
    answer: "Yes, private airport cabs are suitable for families and groups who want to travel together with comfortable seating and convenient luggage arrangements."
  },
  {
    question: "Can business travellers book Navi Mumbai Airport cabs?",
    answer: "Yes, private airport transportation can be arranged for business travellers attending meetings, conferences, client visits, office assignments, and other professional commitments."
  },
  {
    question: "Can I travel between Mumbai and Navi Mumbai Airport by cab?",
    answer: "Yes, private cab transportation can be arranged for direct travel between Mumbai, Navi Mumbai, and Navi Mumbai Airport according to your pickup and destination requirements."
  },
  {
    question: "Can I carry luggage in the airport cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger baggage requirements should be communicated during booking."
  },
  {
    question: "Can I provide flight details while booking?",
    answer: "Yes, you can provide your flight details, travel date, and expected arrival or departure time when arranging an airport transfer."
  },
  {
    question: "Can I book a larger vehicle for airport travel?",
    answer: "Yes, a vehicle can be selected according to your passenger count and luggage requirements so that the airport transfer is planned appropriately."
  },
  {
    question: "How can I book a Navi Mumbai Airport Cab?",
    answer: "Share your airport pickup or drop location, travel date, flight details when applicable, passenger details, luggage requirements, and preferred vehicle with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Kulkarni",
    feedback: "I booked a private cab for travel to Navi Mumbai Airport and found the direct pickup arrangement convenient for my flight schedule. It was useful to have transportation planned in advance.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita More",
    feedback: "Our family travelled to Navi Mumbai Airport with several bags and chose a private cab. The spacious arrangement and direct airport drop made the journey easier for everyone.",
    rating: 5
  }
];










  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport Cab",
  "image": "https://garudcabs.com/assets/images/navi-mumbai-airport-cab.webp",
  "description": "Book Navi Mumbai Airport Cab with Garud Cab for safe, comfortable, and reliable airport transportation. Get Navi Mumbai airport taxi, cab service, airport pickup, airport drop, and advance cab booking options for passengers traveling to Mumbai, Pune, and nearby destinations. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles for business travel, family journeys, hotel transfers, and outstation trips.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/navi-mumbai-airport-cab"
  }
};


  return (
    <div>



<Helmet>
  <title>Navi Mumbai Airport Cab | Airport Taxi & Cab Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport Cab with Garud Cab for reliable airport pickup, drop, taxi, and cab services. Get comfortable Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles for Navi Mumbai Airport travel to Mumbai, Pune, and nearby destinations."
  />

  <meta
    name="keywords"
    content="Navi Mumbai Airport Cab, Navi Mumbai Airport Taxi, Navi Mumbai Airport Cab Service, Navi Mumbai Airport Taxi Service, Cab Service at Navi Mumbai Airport, Taxi Service at Navi Mumbai Airport, Airport Cab Navi Mumbai, Navi Mumbai Airport Cab Booking, Navi Mumbai Airport Pickup Cab, Navi Mumbai Airport Drop Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairportcab;